import { ChangeDetectorRef, Injectable, inject, signal } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { CommonService } from './common.service'
import { ConfigService } from './config.service';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { PlatformService } from './platform.service'; 
@Injectable({
  providedIn: 'root',
})
export class DownloadService {

  constructor(  private commonService: CommonService,
    private configService : ConfigService,
    private platform: PlatformService) {

  }
  private readonly httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    responseType: 'json' as 'json',
  };

  subTimeout:any;

  isDownloadFailed =  signal(false);
  isDownloadDone =  signal(false);
  isDownloadRunning =  signal(false);
  isSequenceDownloadRunning =  signal(false);

  isDownloadFailedAFDB =  signal(false);
  isDownloadDoneAFDB =  signal(false);
  isDownloadRunningAFDB =  signal(false);

  isDownloadFailedATBC =  signal(false);
  isDownloadDoneATBC =  signal(false);
  isDownloadRunningATBC =  signal(false);

  isDownloadFailedBFVD =  signal(false);
  isDownloadDoneBFVD =  signal(false);
  isDownloadRunningBFVD =  signal(false);

  isDownloadFailedNTDX =  signal(false);
  isDownloadDoneNTDX =  signal(false);
  isDownloadRunningNTDX =  signal(false);

  isDownloadFailedVIRO =  signal(false);
  isDownloadDoneVIRO =  signal(false);
  isDownloadRunningVIRO =  signal(false);

  isDownloadFailedVAD =  signal(false);
  isDownloadDoneVAD =  signal(false);
  isDownloadRunningVAD =  signal(false);

  isDownloadFailedPDB =  signal(false);
  isDownloadDonePDB =  signal(false);
  isDownloadRunningPDB =  signal(false);

  allSelectedPDB = signal(false);
  selectedValuesPDB = signal([]);

  allSelectedAFDB = signal(false);
  selectedValuesAFDB = signal([]);

  allSelectedATBC = signal(false);
  selectedValuesATBC = signal([]);

  allSelectedBFVD = signal(false);
  selectedValuesBFVD = signal([]);

  allSelectedNTDX = signal(false);
  selectedValuesNTDX = signal([]);

  allSelectedVIRO = signal(false);
  selectedValuesVIRO = signal([]);

  allSelectedVAD = signal(false);
  selectedValuesVAD = signal([]);

  allSelected = signal(false);
  selectedValues = signal([]);

  private hashedUrl = "";

  private readonly http = inject(HttpClient);

  public updateSelectedValue(selectedValues: string[]){
    this.selectedValues.set(selectedValues);
  }
  public updateSelectedValueSearch(selectedValues: string[], id:string){
    this.selectedValues.set(selectedValues);
    // localStorage.setItem(id, JSON.stringify(selectedValues));
    if (this.platform.isBrowserPlatform()) {
      const platformsessionStorage = this.platform.getSessionStorage();
      platformsessionStorage.setItem(id, JSON.stringify(selectedValues));
    }
    //sessionStorage.setItem("selectedIds", JSON.stringify({id:id, selectedValues:selectedValues}));
  }

  public updateAllSelected(allSelected: boolean){
    this.allSelected.set(allSelected);
  }

  public updateSelectedValueAFDB(selectedValues: string[]){
    this.selectedValuesAFDB.set(selectedValues);
  }

  public updateAllSelectedAFDB(allSelected: boolean){
    this.allSelectedAFDB.set(allSelected);
  }

  public updateSelectedValuesATBC(selectedValues: string[]){
    this.selectedValuesATBC.set(selectedValues);
  }
  
  public updateAllSelectedATBC(allSelected: boolean){
    this.allSelectedATBC.set(allSelected);
  }
  
  public updateSelectedValuesBFVD(selectedValues: string[]){
    this.selectedValuesBFVD.set(selectedValues);
  }
  
  public updateAllSelectedBFVD(allSelected: boolean){
    this.allSelectedBFVD.set(allSelected);
  }

  public updateSelectedValuesNTDX(selectedValues: string[]){
    this.selectedValuesNTDX.set(selectedValues);
  }
  
  public updateAllSelectedNTDX(allSelected: boolean){
    this.allSelectedNTDX.set(allSelected);
  }

  public updateSelectedValuesVIRO(selectedValues: string[]){
    this.selectedValuesVIRO.set(selectedValues);
  }
  
  public updateAllSelectedVIRO(allSelected: boolean){
    this.allSelectedVIRO.set(allSelected);
  }

  public updateSelectedValuesVAD(selectedValues: string[]){
    this.selectedValuesVAD.set(selectedValues);
  }

  public updateAllSelectedVAD(allSelected: boolean){
    this.allSelectedVAD.set(allSelected);
  }

  public updateSelectedValuePDB(selectedValues: string[]){
    this.selectedValuesPDB.set(selectedValues);
  }

  public updateAllSelectedPDB(allSelected: boolean){
    this.allSelectedPDB.set(allSelected);
  }

  public initiateDownload(downloadUrl, downloadType, searchTerm, selectedValues, isSequenceSearch, whichDownload): void {
    if(downloadType === "allresultscsv"){
      if (downloadUrl) {
       
        if(isSequenceSearch){
          this.isSequenceDownloadRunning.set(true);
        }else{
          this.isDownloadRunning.set(true);
        }
       
        this.downloadCSVFile(downloadUrl, searchTerm, isSequenceSearch);
      } else {
        alert(`Don't have ${downloadType} csv file url from API`);
      }
    }
    if(downloadType === "modelcoordicate"){
      this.postFile(selectedValues, searchTerm, isSequenceSearch, whichDownload);
    }
  }

  public downloadCSVFile(csvUrl: string, searchTerm, isSequenceSearch: boolean) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'blob' as 'json'
    };

    this.http.get(csvUrl, options).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'text/csv' });
        const windowWithURL = this.platform.getWindow() as Window & { URL: typeof URL };
        const url = windowWithURL.URL.createObjectURL(blob);

        const a = this.platform.getDocument()?.createElement('a');
        a.href = url;
        if(!isSequenceSearch){
          a.download = `${searchTerm}-results-csv.csv`; // The name for the downloaded file
        }
        this.platform.getDocument()?.body.appendChild(a);
        a.click();
       
        if(isSequenceSearch){
          this.isSequenceDownloadRunning.set(false);
        }else{
          this.isDownloadRunning.set(false);
        }
       
        this.isDownloadDone.set(true);
        if(this.isDownloadDone) {
          setTimeout(() => {
            this.isDownloadDone.set(false);
          }, 7000); 
        }
        this.clearSelectionSearch(searchTerm);
        this.platform.getDocument()?.body.removeChild(a);
        windowWithURL.URL.revokeObjectURL(url);
      },
      (error) => {
        alert('There was an error downloading the file');
      }
    );
  }

  public postFile(selectedValues, searchTerm, isSequenceSearch, whichDownload): void {
    const downloadApiUrl = this.configService.getConfig().downloadApiUrl;
    const auth = this.configService.getConfig().apiKey ? `?key=${this.configService.getConfig().apiKey}` : '';
    const postapiurl = `${downloadApiUrl}/submit/${auth}`;
    let fdsConfig;
    if(selectedValues){
      fdsConfig = {
        "ids": selectedValues,
        "files": ["mmcif", "pdb", "pae"]
      }
    }
    if(whichDownload === 'search_page')
    {
      if(isSequenceSearch){
        this.isSequenceDownloadRunning.set(true);
      }else{
        this.isDownloadRunning.set(true);
      }
    }
    if(whichDownload === 'afdb'){
      this.isDownloadRunningAFDB.set(true);
    }

    if(whichDownload === 'atbc'){
      this.isDownloadRunningATBC.set(true);
    }

    if(whichDownload === 'bfvd'){
      this.isDownloadRunningBFVD.set(true);
    }

    if(whichDownload === 'ntdx'){
      this.isDownloadRunningNTDX.set(true);
    }

    if(whichDownload === 'viro'){
      this.isDownloadRunningVIRO.set(true);
    }

    if(whichDownload === 'vadb'){
      this.isDownloadRunningVAD.set(true);
    }

    this.commonService.postApiData(postapiurl, fdsConfig).subscribe(async (response) => {
      if(response && (response.status == 200)){
        if(response && response.job_id){
          this.getFileLinkForDownload(response.job_id, searchTerm, isSequenceSearch, whichDownload);
        }
      }
    },
    (error) => {
      const code =  error.status;
      this.isDownloadRunning.set(false);
      this.isSequenceDownloadRunning.set(false);

      this.isDownloadFailed.set(true);

      this.isDownloadRunningAFDB.set(false);
      this.isDownloadFailedAFDB.set(true);

      this.isDownloadRunningATBC.set(false);
      this.isDownloadFailedATBC.set(true);

      this.isDownloadRunningBFVD.set(false);
      this.isDownloadFailedBFVD.set(true);

      this.isDownloadRunningNTDX.set(false);
      this.isDownloadFailedNTDX.set(true);

      this.isDownloadRunningVIRO.set(false);
      this.isDownloadFailedVIRO.set(true);

      this.isDownloadRunningVAD.set(false);
      this.isDownloadFailedVAD.set(true);
      this.updateSelectedValueSearch([], searchTerm)
      this.updateAllSelected(false);
      // this.changeDetectorRef.detectChanges();
    });
  }
  
  private getFileLinkForDownload(job_id, searchTerm, isSequenceSearch, whichDownload){
    const downloadApiUrl = this.configService.getConfig().downloadApiUrl;
    const auth = this.configService.getConfig().apiKey ? `?key=${this.configService.getConfig().apiKey}` : '';
    const getapiurl = `${downloadApiUrl}/status/${job_id}${auth}`;
      this.commonService.getApiDatawithStatus(getapiurl).subscribe(async (response: HttpResponse<any>) => {
      const code = response.status;
      if(response && response.body.message){
        if(code === 202){
          if(response.body.message && (response.body.message.startsWith("Job still running")))
          {
            if(whichDownload === 'search_page')
            {
              if(isSequenceSearch){
                this.isSequenceDownloadRunning.set(true);
              }else{
                this.isDownloadRunning.set(true);
              }
            }
            if(whichDownload === 'afdb'){
              this.isDownloadRunningAFDB.set(true);
            }
            if(whichDownload === 'atbc'){
              this.isDownloadRunningATBC.set(true);
            }
            if(whichDownload === 'bfvd'){
              this.isDownloadRunningBFVD.set(true);
            }
            if(whichDownload === 'ntdx'){
              this.isDownloadRunningNTDX.set(true);
            }
            if(whichDownload === 'viro'){
              this.isDownloadRunningVIRO.set(true);
            }
            if(whichDownload === 'vadb'){
              this.isDownloadRunningVAD.set(true);
            }
            this.subTimeout = setTimeout(() => {
              this.getFileLinkForDownload(job_id, searchTerm, isSequenceSearch, whichDownload);
            }, 10000);
          }
        }
        if(code === 200 && response.body.url != ""){
          this.downloadFileAFDB(response.body.url, searchTerm, whichDownload);
        }
      } 
    },
    err => {
      this.isDownloadRunning.set(false);
      this.isSequenceDownloadRunning.set(false);
      this.isDownloadFailed.set(true);

      this.isDownloadRunningAFDB.set(false);
      this.isDownloadFailedAFDB.set(true);

      this.isDownloadRunningATBC.set(false);
      this.isDownloadFailedATBC.set(true);

      this.isDownloadRunningBFVD.set(false);
      this.isDownloadFailedBFVD.set(true);

      this.isDownloadRunningNTDX.set(false);
      this.isDownloadFailedNTDX.set(true);

      this.isDownloadRunningVIRO.set(false);
      this.isDownloadFailedVIRO.set(true);

      this.isDownloadRunningVAD.set(false);
      this.isDownloadFailedVAD.set(true);
    });
  }

  public downloadFileAFDB(url: string, searchTerm: string, whichDownload:string){
    if (!url) {
      console.error("Invalid URL provided");
      return;
    }
    const link = this.platform.getDocument()?.createElement('a');
    const fileName = `${searchTerm}-modeldata.zip`;
    link.download = fileName;
    link.href = url;
    link.target = '_blank';
    this.platform.getDocument()?.body.appendChild(link);
    link.click();
    this.platform.getDocument()?.body.removeChild(link);
    const windowWithURL = this.platform.getWindow() as Window & { URL: typeof URL };

    windowWithURL.URL.revokeObjectURL(url);
    if(whichDownload === "afdb"){
      this.isDownloadRunningAFDB.set(false);
      this.isDownloadDoneAFDB.set(true);
      this.clearSelection('afdb');
    }
    if(whichDownload === "atbc"){
      this.isDownloadRunningATBC.set(false);
      this.isDownloadDoneATBC.set(true);
      this.clearSelection('atbc');
    }
    if(whichDownload === "bfvd"){
      this.isDownloadRunningBFVD.set(false);
      this.isDownloadDoneBFVD.set(true);
      this.clearSelection('bfvd');
    }
    if(whichDownload === "ntdx"){
      this.isDownloadRunningNTDX.set(false);
      this.isDownloadDoneNTDX.set(true);
      this.clearSelection('ntdx');
    }
    if(whichDownload === "viro"){
      this.isDownloadRunningVIRO.set(false);
      this.isDownloadDoneVIRO.set(true);
      this.clearSelection('viro');
    }
    if(whichDownload === "vadb"){
      this.isDownloadRunningVAD.set(false);
      this.isDownloadDoneVAD.set(true);
      this.clearSelection('vadb');
    }
    if(whichDownload === 'search_page'){
      this.isDownloadRunning.set(false);
      this.isSequenceDownloadRunning.set(false);
      this.isDownloadDone.set(true);
    }

    if(this.isDownloadDoneAFDB) {
      setTimeout(() => {
        this.isDownloadDoneAFDB.set(false);
      }, 7000); 
    }
    if(this.isDownloadDoneATBC) {
      setTimeout(() => {
        this.isDownloadDoneATBC.set(false);
      }, 7000); 
    }
    if(this.isDownloadDoneBFVD) {
      setTimeout(() => {
        this.isDownloadDoneBFVD.set(false);
      }, 7000); 
    }
    if(this.isDownloadDoneNTDX) {
      setTimeout(() => {
        this.isDownloadDoneNTDX.set(false);
      }, 7000); 
    }
    if(this.isDownloadDoneVIRO) {
      setTimeout(() => {
        this.isDownloadDoneVIRO.set(false);
      }, 7000);
    }
    if(this.isDownloadDoneVAD) {
      setTimeout(() => {
        this.isDownloadDoneVAD.set(false);
      }, 7000);
    }

    this.clearSelectionSearch(searchTerm);
  }


  closeToast(): void {
    this.isDownloadFailed.set(false);
    this.isDownloadDone.set(false);

    this.isDownloadFailedAFDB.set(false);
    this.isDownloadDoneAFDB.set(false);

    this.isDownloadFailedPDB.set(false);
    this.isDownloadDonePDB.set(false);

    this.isDownloadFailedATBC.set(false);
    this.isDownloadDoneATBC.set(false);
      
    this.isDownloadFailedBFVD.set(false);
    this.isDownloadDoneBFVD.set(false);

    this.isDownloadFailedNTDX.set(false);
    this.isDownloadDoneNTDX.set(false);

    this.isDownloadFailedVIRO.set(false);
    this.isDownloadDoneVIRO.set(false);

    this.isDownloadFailedVAD.set(false);
    this.isDownloadDoneVAD.set(false);
  }

  clearSelection(flag) {
    if(flag === 'afdb'){
      this.allSelectedAFDB.set(false);
      this.selectedValuesAFDB.set([]);
      this.allSelected.set(false);
      this.selectedValues.set([]);
    }
    if(flag === 'atbc'){
      this.allSelectedATBC.set(false);
      this.selectedValuesATBC.set([]);
    }
    if(flag === 'bfvd'){
      this.allSelectedBFVD.set(false);
      this.selectedValuesBFVD.set([]);
    }
    if(flag === 'ntdx'){
      this.allSelectedNTDX.set(false);
      this.selectedValuesNTDX.set([]);
    }
    if(flag === 'viro'){
      this.allSelectedVIRO.set(false);
      this.selectedValuesVIRO.set([]);
    }
    if(flag === 'vadb'){
      this.allSelectedVAD.set(false);
      this.selectedValuesVAD.set([]);
    }
    if(flag === 'pdb'){
      this.allSelectedPDB.set(false);
      this.selectedValuesPDB.set([]);
    }
  }

  clearSelectionSearch(searchTerm) {
    this.allSelected.set(false);
    this.selectedValues.set([]);
    this.allSelectedAFDB.set(false);
    this.selectedValuesAFDB.set([]);

    this.allSelectedATBC.set(false);
    this.selectedValuesATBC.set([]);

    this.allSelectedBFVD.set(false);
    this.selectedValuesBFVD.set([]);

    this.allSelectedNTDX.set(false);
    this.selectedValuesNTDX.set([]);

    this.allSelectedVIRO.set(false);
    this.selectedValuesVIRO.set([]);

    this.allSelectedVAD.set(false);
    this.selectedValuesVAD.set([]);

    const platformsessionStorage = this.platform.getSessionStorage();
    platformsessionStorage.setItem(searchTerm, JSON.stringify([])); 
    platformsessionStorage.removeItem(searchTerm);
  }

  public postPDBFile(selectedValues: string[], searchTerm): void {
    const postapiurl =  `${this.configService.getConfig().pdbeBaseApiUrl}/download/api/pdb/entry/all`;
    let fdsConfig;
    if(selectedValues){
      fdsConfig = {
        "ids": selectedValues
      }
    }
    this.isDownloadRunningPDB.set(true);
    this.commonService.postApiData(postapiurl, fdsConfig).subscribe(async (response) => {
      if(response && (response.status == 200)){
        if(response && response.url){
          this.getDownloadFilePDB(response.url, searchTerm);
        }
      }
    },
    (error) => {
      const code =  error.status;
      this.isDownloadRunningPDB.set(false);
      this.isDownloadFailedPDB.set(true);
    });
  }

  private getDownloadFilePDB(getapiurl: string, searchTerm: string) {
    fetch(getapiurl)
      .then((response) => { 
        if (response.status === 202) {
          this.isDownloadRunningPDB.set(true);
          this.isDownloadRunning.set(true);
          setTimeout(() => {
            this.getDownloadFilePDB(getapiurl, searchTerm);
          }, 10000); 
        } if(response.status === 200){
          this.isDownloadRunningPDB.set(false);
          this.isDownloadRunning.set(false);
          this.isSequenceDownloadRunning.set(false);
          return response.blob();
        }
        if(response.status === 500 || response.status === 400 || response.status === 429 ||  response.status === 0){
         throw Error;
        }
      })
      .then((blob) => {
        if(blob !== undefined){
          this.downloadFilePDB(blob, searchTerm);
        }
      })
      .catch((error) => {
        this.isDownloadRunning.set(false);
        this.isSequenceDownloadRunning.set(false);
        this.isDownloadFailed.set(true);
        this.isDownloadRunningPDB.set(false);
        this.isDownloadFailedPDB.set(true);
        this.clearSelection('pdb');
      });
  }
  private downloadFilePDB(blobResponse: Blob, searchTerm) {
    const blob = new Blob([blobResponse], { type: 'application/octet-stream' });
    const windowWithURL = this.platform.getWindow() as Window & { URL: typeof URL };
    const url = windowWithURL.URL.createObjectURL(blob);

    const platformdocument = this.platform.getDocument();
    const a = platformdocument.createElement('a');
    a.href = url;
    a.download = `${searchTerm}-modeldata.zip`; 
    platformdocument.body.appendChild(a);
    a.click(); 
    platformdocument.body.removeChild(a);
  
    windowWithURL.URL.revokeObjectURL(url);
    this.isDownloadRunningPDB.set(false);
    this.isDownloadDonePDB.set(true);
    if(this.isDownloadDonePDB) {
      setTimeout(() => {
        this.isDownloadDonePDB.set(false);
      }, 7000); 
    }
    this.clearSelection('pdb');
  }
}
